// removed by extract-text-webpack-plugin
module.exports = {"main":"style__main___3W2AA"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/style.scss
// module id = 1026
// module chunks = 0